import { useRouteError, Link } from "react-router-dom";

// ── Página de error ─────────────────────────────────────────────────────
// Se muestra cuando una ruta no existe o cuando un loader/acción del
// router lanza un error. Antes este archivo estaba vacío, por eso
// React fallaba con "Element type is invalid ... got: object".
const ErrorPage = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="container text-center" style={{ padding: "80px 20px" }}>
      <h1>¡Ups!</h1>
      <p>Lo sentimos, ocurrió un error inesperado.</p>
      <p>
        <i>
          {error?.statusText || error?.message || "Página no encontrada"}
        </i>
      </p>
      <Link to="/" className="btn btn-secondary mt-3">
        Volver al inicio
      </Link>
    </div>
  );
};

export default ErrorPage;